require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-emerald-health-registration-microservice.json") })
        }
      }, "path---projects-emerald-health-registration-microservice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-emerald-health-registration-microservice!./.cache/json/projects-emerald-health-registration-microservice.json
// module id = 521
// module chunks = 231608221292675